export function safeParseJson(str: string) {
  try {
    return JSON.parse(str);
  } catch (e) {
    // console.log(e, 'error reading json');
  }
  return str;
}
